import type { AxiosError } from 'axios';
import { openNativeLauncher } from './nativeApp';

/** 401 do middleware JWT / sessão Klinvia — não confundir com segredo de hub, webhook, etc. */
const KLINVIA_SESSION_ERROR_PATTERNS: RegExp[] = [
  /token de acesso necessário/i,
  /token inválido/i,
  /token expirado/i,
  /usuário não encontrado/i,
  /autenticação necessária/i,
  /sessão expirada/i,
];

function requestPath(url: string | undefined): string {
  const raw = String(url || '').split('?')[0];
  try {
    if (raw.startsWith('http://') || raw.startsWith('https://')) {
      return new URL(raw).pathname;
    }
  } catch {
    // path relativo
  }
  return raw;
}

function responseErrorText(data: unknown): string {
  if (!data || typeof data !== 'object') return '';
  const d = data as Record<string, unknown>;
  return [d.error, d.message]
    .filter((v) => typeof v === 'string')
    .join(' ')
    .trim();
}

function isKlinviaSessionErrorMessage(text: string): boolean {
  if (!text) return false;
  return KLINVIA_SESSION_ERROR_PATTERNS.some((re) => re.test(text));
}

/**
 * Só deve derrubar a sessão global quando o 401 é claramente do JWT do usuário,
 * ou quando a validação explícita em /auth/me falhou.
 */
export function shouldClearSessionOn401(error: AxiosError): boolean {
  if (error.response?.status !== 401) return false;
  if (error.config?.skipAuthRedirect) return false;

  const path = requestPath(error.config?.url);
  if (/\/auth\/login\b/i.test(path)) return false;

  if (/\/auth\/me\b/i.test(path)) return true;

  if (/\/payment-notification\/status\b/i.test(path)) return false;

  return isKlinviaSessionErrorMessage(responseErrorText(error.response?.data));
}

export function clearAuthStorageAndRedirectToLogin(): void {
  if (typeof window === 'undefined') return;

  localStorage.removeItem('auth_token');
  localStorage.removeItem('auth_user');
  localStorage.removeItem('token');
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('user');

  if (openNativeLauncher('session')) return;

  const onLoginPage = window.location.pathname.startsWith('/login');
  if (!onLoginPage) {
    window.location.href = '/login';
  }
}
